<template>
  <div>
    <v-dialog v-model="$store.state.statShowFrmLogin" persistent width="700">
      <v-card>
        <v-card-title class="fix-font error lighten-2"
          ><v-icon left>mdi-key</v-icon> เข้าสู่ระบบ
        </v-card-title>
        <v-card-text>
          <form class="pt-3">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="$store.state.dataFrm.tea_card_id"
                  label="เลขบัตรประชาชน"
                  maxlength="13"
                  counter="13"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <DatetimepickerTH
                  label="วันเดือนปีเกิด"
                  @callBackValue="
                    (val) => ($store.state.dataFrm.tea_birthday = val)
                  "
                ></DatetimepickerTH>
              </v-col>
            </v-row>
          </form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="close"
            ><v-icon left>mdi-close-box</v-icon> ปิดหน้านี้
          </v-btn>
          <v-btn color="primary" @click="checkSignIn">
            สมัครงาน | เข้าสู่ระบบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pdpaVue :dialog="statShow"></pdpaVue>
  </div>
</template>
<script>
import DatetimepickerTH from "./datetimepickerTH";
import swal2 from "sweetalert2";
import Swal from "sweetalert2";
import Axios from "axios";
import pdpaVue from "./pdpa.vue";
export default {
  components: { DatetimepickerTH, pdpaVue },
  name: "login",
  data() {
    return {
      statShow: false,
    };
  },
  mounted() {
    if (this.$store.getters.userRegis != undefined) {
      if (this.$store.getters.get_selJob.length == 0) {
        swal2
          .fire("ตรวจสอบข้อมูล", "กรุณาเลือกงานที่ต้องการสมัคร", "warning")
          .then((res) => {
            if (res.value) {
              this.$router.push("./");
            }
          });
      }
    } else {
      this.$router.push("./");
    }
  },
  methods: {
    close() {
      this.$store.state.statShowFrmLogin = false;
    },
    async checkSignIn() {
      await this.$store.dispatch("get_Educate_Level");
      await this.$store.dispatch("get_userRegis").then(async (res) => {
        // console.log(this.$store.state.dataFrm);
        // console.log(res);
        if (res.status_regis != "loginfalse") {
          await Axios.post(
            "https://www.lannapoly.ac.th/api/index.php?url=pdpa/get/PDPA_Teacher_test",
            {
              card_id: this.$store.state.dataFrm.tea_card_id,
            }
          ).then(async (res1) => {
            if (res1.data.length == 0) {
              this.statShow = true;
            } else {
              this.statShow = false;
            }
          });
         
          this.$store.dispatch("list_year");
          this.$store.dispatch("get_PreName");
          this.$store.dispatch("get_ParentStatus");
          this.$store.dispatch("get_Nation");
          this.$store.dispatch("get_Religion");
          this.$store.dispatch("get_Blood");
          this.$store.dispatch("get_Sex");
          this.$store.dispatch("get_Status");
          this.$store.dispatch("get_Province");
          this.$store.dispatch("get_District");
          this.$store.dispatch("get_Locality");
          this.$store.dispatch("get_Occupation");
          this.$store.dispatch("get_PersonalDoc");
          this.$store.dispatch("get_LivingState");
          this.$store.state.statFromLogin = true;
          await this.$router.push("resume");
          this.close();
        } else {
          Swal.fire(
            "เตือน!!!",
            "กรุณากรอกวันเดือนปีเกิดให้ถูกต้อง!!!!หากกรอกข้อมูลผิดพลาดกรุณาติดต่อ Page-FB:วิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา เชียงใหม่",
            "error"
          );
        }
      });
    },
  },
};
</script>
<style lang=""></style>
